import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ADMIN_PATH } from "./config/adminPath";
import { AdminDashboard } from "./pages/AdminDashboard";

const LandingPage = lazy(() =>
  import("./pages/LandingPage").then((m) => ({ default: m.LandingPage }))
);
const EntrevistaBobapet = lazy(() =>
  import("./pages/blog/EntrevistaBobapet").then((m) => ({ default: m.EntrevistaBobapet }))
);

const routeFallback = (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 text-gray-600">
    Carregando…
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={routeFallback}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/blog/bobapet-banho-tosa-ia" element={<EntrevistaBobapet />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path={ADMIN_PATH} element={<AdminDashboard />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
